import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about.vue')
  },
  {
    path: '/customer',
    name: 'customer',
    component: () => import('../views/customer.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/service.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
